import React, { useState, useEffect, useRef, forwardRef} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';
import { AgGridReact } from "ag-grid-react";
import { AllEnterpriseModule } from "ag-grid-enterprise";
import { ModuleRegistry, AllCommunityModule, themeBalham } from 'ag-grid-community';
import axios from "axios";
import { Drawer } from '@material-ui/core';
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { parse } from 'date-fns/fp';
import { format, isValid } from 'date-fns'
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import InputRenderer from "./RenderInput.js";
import { warnmsg } from '../modules/msgboxstore';
import { isEmpty, CellType, DeepCopy, toStringDate, toStringYM, toStringYYYY, storageKey, storageExistsKey } from '../modules/appLibrary';
import { getAxiosAuthConfig, getResponseErrorDescription, hasValidLoginSession, isUnauthorizedResponse } from '../modules/authToken';
import { resetstore } from '../modules/menustore';
import { resetenv } from '../modules/environstore';
import { resetuser } from '../modules/userstore';
import { datepickeropen, setsearchdata } from '../modules/searchliststore';
import SearchList from '../components/SearchList';

// 必要なモジュールを登録
ModuleRegistry.registerModules([
    AllEnterpriseModule,
    AllCommunityModule
]);

//---------------------------------------------------------------------
//  検索条件パネル
//
//  controller
//  columninfo
//  subkey:SerchList内から起動='inner'
//  fnc
//---------------------------------------------------------------------
//  処理仕様
//      検索履歴(10件)をlocalstorageに保存
//---------------------------------------------------------------------
export default function SearchPanel(props) {
    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const datainfo = useSelector(state => state.search.data);

    const dispatch = useDispatch();
    const history = useHistory();
    const [anchorEl, setAnchorEl] = useState(null);
    const [rowData, setRowData] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [searchindex, setsearchindex] = useState(-1);
    const [preSearchDisable, setpreSearchDisable] = useState(false);
    const [nextSearchDisable, setnextSearchDisable] = useState(true);
    const CELLTYPE = CellType();
    const [open, setopen] = useState(false);
    const [savekey, setsavekey] = useState(null);
    const [items, setitems] = useState(null);

    const [slopen, setslopen] = useState(false);
    const [slmultiple, setslmultiple] = useState(false);
    const [sllabel, setsllabel] = useState('');
    const [slrowid, setslrowid] = useState('');
    const [sldata, setsldata] = useState(null);
    const [slrowdata, setslrowdata] = useState(null);
    const [sldoApply, setsldoApply] = useState(0);
    const [dpopen, setdpopen] = useState(false);
    const searchlistdataidRef = useRef(null);
    function getRadioDefaultValue(item) {
        if (isEmpty(item) || item.datatype !== CELLTYPE.RADIO) return '';
        const options = Array.isArray(item.options) ? item.options : [];
        if (options.length === 0) return '';
        return String(options[0].code ?? '');
    }

    useEffect(() => {
        setopen(props.open);
        if (props.open) {
            searchlistdataidRef.current = isEmpty(datainfo) ? null : DeepCopy(datainfo);
            setsavekey ( props.savekey);
            setitems ( props.items);
        } else {
            searchlistdataidRef.current = null;
        }
    }, [props.open])

    useEffect(() => {
        if (isEmpty(items)) return;
        if (items.length === 0) return;
        let rows = [];
        for (let i = 0; i < items.length; i++) {
            let data = {
                datatype: items[i].datatype,
                label: items[i].columnnm,
                table: items[i].table,
                columnid: items[i].columnid,
                dataid: items[i].dataid,
                seqno: items[i].seqno,
                options: items[i].options,
                desableoption: items[i].desableoption,
                value: getRadioDefaultValue(items[i]),
                value2: '',
                filter: ''
            }
            rows.push(data);
        }
        //条件項目表示
        setRowData(rows);
    }, [items])


    //masterlist selectitem
    function setsearchitem(param) {
        let datasource = DeepCopy(rowData);
        var row = datasource.find(e => e.columnid === param.key);
         if (!isEmpty(row)) {
            if (param.datainfo.datatype === CELLTYPE.MASTERREF) {
                let item = items.find(col => col.columnid === param.key);
                row.value = param.items[0].data[item.dbcolumn];
                row.value2 = "";
            } else if (param.datainfo.datatype === CELLTYPE.DATE || param.datainfo.datatype === CELLTYPE.SEARCHDATE) {
                row.value = toStringDate(param.value);
            //    props.fnc.searchlistclose();
                props.fnc.datepickerclose();
            } else if (param.datainfo.datatype === CELLTYPE.SEARCHYM || param.datainfo.datatype === CELLTYPE.SEARCHYMRANGE ||
                       param.datainfo.datatype === CELLTYPE.SEARCHYMSTR || param.datainfo.datatype === CELLTYPE.SEARCHYMRANGESTR ) {
                row.value = toStringYM(param.value);
            //    props.fnc.searchlistclose();
                props.fnc.datepickerclose();
            } else if (param.datainfo.datatype === CELLTYPE.YEAR) {
                row.value = toStringYYYY(param.value);
                //props.fnc.searchlistclose();
                props.fnc.datepickerclose();
           } else {
                row.value = param.value;
            }
        }
        setRowData(datasource);
        setslopen(false);
        setdpopen(false);
    }
    //Date value2
    function setsearchitem2(param) {
        let datasource = DeepCopy(rowData);
        var row = datasource.find(e => e.columnid === param.key);
        if (!isEmpty(row)) {
            if (param.datainfo.datatype === CELLTYPE.DATE || param.datainfo.datatype === CELLTYPE.SEARCHDATE) {
                row.value2 = toStringDate(param.value);
                props.fnc.searchlistclose();
            } else if (param.datainfo.datatype === CELLTYPE.SEARCHYM || param.datainfo.datatype === CELLTYPE.SEARCHYMRANGE ||
                       param.datainfo.datatype === CELLTYPE.SEARCHYMSTR || param.datainfo.datatype === CELLTYPE.SEARCHYMRANGESTR  ) {
                row.value2 = toStringYM(param.value);
                //props.fnc.searchlistclose();
                props.fnc.datepickerclose();
            } else {
                row.value2 = param.value;
            }
        }
        setRowData(datasource);
        setslopen(false);
        setdpopen(false);
    }

    function isMaster(columnid) {
        let item = items.find(col => col.columnid === columnid);
        if (isEmpty(item)) return false;
        return item.datatype === CELLTYPE.MASTER || item.datatype === CELLTYPE.MASTERCODE;
    }
    function getcolinfo(columnid) {
        if (isEmpty(props.columninfo)) {
            return items.find(col => col.columnid === columnid);
        } else {
            var info = props.columninfo.find(col => col.columnid === columnid);
            if (!isEmpty(info)) return info;
            return items.find(col => col.columnid === columnid);
        }
    }

    function handleClick(event){
        setAnchorEl(event.currentTarget);
    };
    function handleClose (){
        setAnchorEl(null);
    };

    //Date Picker
    const [startDate, setStartDate] = useState(new Date());
    const DatePickerCustomInput = forwardRef(({ value, onClick }, ref) => (
        <div style={{ display:'none' }}>
            <button id="datepicker" className="example-custom-input" onClick={onClick} ref={ref}></button>
        </div>
    ));
    function onDateChange(date) {
        setStartDate(date);
        let strvalue = format(date, 'yyyy/MM/dd');
        let cell = gridApi.getFocusedCell();
        let rowNode = gridApi.getDisplayedRowAtIndex(cell.rowIndex);
        rowNode.setDataValue(cell.column.colId, strvalue);
    }

    function Execute() {
        if (!isEmpty(searchlistdataidRef.current)) {
            dispatch(setsearchdata(DeepCopy(searchlistdataidRef.current)));
        }
        gridApi.stopEditing();
        //検索条件収集
        var itemdata = [];
        gridApi.forEachNode(function (node) {
            if (node.data.value !== '' || node.data.filter !== '' ||
                ((node.data.datatype === CELLTYPE.DATE || node.data.datatype === CELLTYPE.NUM) && node.data.value2 !== '')) {
                let data = {
                    table:node.data.table,
                    columnid: node.data.columnid,
                    value: node.data.value.toString(),
                    value2: node.data.value2.toString(),
                    filter: node.data.filter,
                    datatype: node.data.datatype,
                }
                itemdata.push(data);
            }
        });
        //条件実行
        //props.doApply(itemdata, searchlistdataidRef.current);
        props.doApply(itemdata);

        //検索条件保存
        saveSearchValue(itemdata);
    }
    //検索条件保存
    function saveSearchValue(item) {
        if (item.length > 1) 
            item.sort(function (a, b) {
                return (a.cloumnid < b.columnid) ? -1 : 1;
            });
        const data = {
            update: format(new Date(), 'yyyy/MM/dd HH:mm:ss'),
            values:item
        }
        const key = storageKey(corpkey, account, props.controller + "_search");
        let itemdata = getSearchData();
        if (itemdata !== null) {
            //同一条件存在チェック
            for (let i = 0; i < itemdata.length; i++) {
                if (JSON.stringify(itemdata[i].values) === JSON.stringify(item)) {
                    itemdata.splice(i,1);
                    break;
                }
            }
            itemdata.push(data);
            if (itemdata.length > 10) {    //保存件数超過
                //最も古いデータを削除
                itemdata.sort((a, b) => a.update - b.update);
                itemdata.splice(0, 1);
            }
            localStorage.setItem(key, JSON.stringify(itemdata));
        } else {
            let itemdata = [];
            itemdata.push(data);
            localStorage.setItem(key, JSON.stringify(itemdata));
        }
        setsearchindex(-1);
        setnextSearchDisable(true);
        setpreSearchDisable(false);
    }
    //現在条件取得
    function curSearch() {
        let itemdata = getSearchData();
        if (itemdata === null) {
            dispatch(warnmsg("条件は存在しませんでした"));
            return;
        }
        setSearchdata(itemdata[0].values)
        setsearchindex(0);
        setnextSearchDisable(true);
        setpreSearchDisable(itemdata.length <= 1);
    }
    function prevSearch() {
        let itemdata = getSearchData();
        if (itemdata === null) {
            dispatch(warnmsg("条件は存在しませんでした"));
            return;
        }
        let index = 0;
        if (searchindex !== -1) {
            if (searchindex + 1 < itemdata.length)
                index = searchindex + 1;
            else
                index = searchindex;
        }
        if (index !== searchindex) {
            setSearchdata(itemdata[index].values)
            setsearchindex(index);
        }
        setnextSearchDisable(index === 0);
        setpreSearchDisable(itemdata.length - index < 2);
    }
    function nextSearch() {
        let itemdata = getSearchData();
        if (itemdata === null) {
            dispatch(warnmsg("条件は存在しませんでした"));
            return;
        }
        let index = 0;
        if (searchindex > 0) {
            index = searchindex - 1;
        }
        if (index !== searchindex) {
            setSearchdata(itemdata[index].values)
            setsearchindex(index);
        }
        setnextSearchDisable(index === 0);
        setpreSearchDisable(itemdata.length - index < 2);
    }
    function setSearchdata(values) {
        try {
            gridApi.forEachNode(function (node) {
                let result = values.find(e => e.columnid === node.data.columnid);
                if (result === undefined) {
                    node.setDataValue('value', getRadioDefaultValue(node.data));
                    node.setDataValue('value2', '');
                    node.setDataValue('filter', '');
                } else {
                    if (isMaster(node.data.columnid)) {
                        let colinfo = getcolinfo(node.data.columnid);
                        if (!props.fnc.existMaster(result.dataid, result.value)) {
                            //サーバーより情報を取得
                            props.fnc.getMasterdata(colinfo.dataid, result.value, '', [], null, (data) => _getmaster(data));
                        }
                    }
                    node.setDataValue('value2', result.value2);
                    node.setDataValue('value', result.value);
                    node.setDataValue('filter', result.filter);
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
    function _getmaster(data) {
        if (!isEmpty(data)) {
            props.fnc.setMaster(data);
            props.fnc.wait(false);
        }
    }
    //条件履歴取得
    function getSearchData() {
        const key = storageKey(corpkey, account, props.controller + "_search");
        if (!storageExistsKey(key))
            return null;

        let itemdata = JSON.parse(localStorage.getItem(key));
        if (itemdata.length > 1) {
            itemdata.sort(function (a, b) {
                return (a.update > b.update) ? -1 : 1;
            });
        }
        return itemdata;
    }

    function handleLoginExpired() {
        dispatch(warnmsg("ページの有効期限が切れました。再度ログインしてください。"));
        dispatch(resetuser());
        dispatch(resetstore());
        dispatch(resetenv());
        history.push('/');
    }

    //抽出条件保存
    async function SaveCondition(params) {
        var itemdata = [];
        gridApi.forEachNode(function (node) {
            if (!isEmpty(node.data.value) || !isEmpty(node.data.value2) || !isEmpty(node.data.filter)) 
                itemdata.push(node.data);
        });
        if (itemdata.length === 0) {
            props.fnc.warnmsg("条件が指定されていません");
            return;
        }
        props.fnc.confmsg("表示中の条件を起動表示抽出条件として適用します。よろしいですか？", () => Apply());
        function Apply() {
            props.fnc.postaxios('common/SaveCondition',
                { "controller": props.controller, "subkey": props.subkey, "type":"0", items:itemdata },
                {
                    onSuccess: function (data) {
                        props.fnc.wait(false);
                        props.fnc.success();
                    },
                }
            )
            handleClose();
        }
    }
    //抽出条件削除
    async function RemoveCondition(params) {
        props.fnc.confmsg("現在の起動表示抽出条件をクリアします。よろしいですか？", () => Apply());
        function Apply() {
            props.fnc.postaxios('common/RemoveCondition',
                { "controller": props.controller, "subkey": props.subkey, "type": "0" },
                {
                    onSuccess: function (data) {
                        props.fnc.wait(false);
                        props.fnc.success();
                    },
                }
            )
            handleClose();
        }
    }
    //抽出条件表示
    async function showCondition(params) {
        props.fnc.postaxios('common/LoadCondition',
            { "controller": props.controller, "subkey": props.subkey, "type": "0"},
            {
                onSuccess: function (data) {
                    if (data.items.length === 0) {
                        props.fnc.warnmsg("起動表示条件は適用されていません");
                    } else {
                        setSearchdata(data.items);
                        props.fnc.success();
                    }
                    props.fnc.wait(false);
                },
            }
        )
        handleClose();
    }

    //検索項目並び順保存
    async function SaveOrder(params) {
        var itemdata = [];
        gridApi.forEachNode(function (node) {
            itemdata.push(node.data.columnid.toString());
        });
        try {
            if (!hasValidLoginSession({ corpkey, account })) {
                handleLoginExpired();
                return;
            }
            const params = {
                corpkey: corpkey,
                account: account,
                controller: savekey,
                subkey: "",
                items: itemdata
            }
            let formData = new FormData();
            Object.entries(params).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach((v, i) => {
                        formData.append(key + '[]', v)
                    })
                } else {
                    formData.append(key, value)
                }
            })
            const res = await axios.post('common/SaveSearchOrder', formData, getAxiosAuthConfig());
            const data = res.data;
            if (data.status) {
                //seqno update
                var seqno = 0;
                gridApi.forEachNode(function (node) {
                    node.data.seqno = seqno;
                    seqno++;
                });
            }else {
                dispatch(warnmsg("並び順の保存に失敗しました"));
                return;
            }
        } catch (error) {
            const errDescription = getResponseErrorDescription(error);
            if (!isEmpty(errDescription)) {
                dispatch(warnmsg(errDescription));
                return;
            }
            if (isUnauthorizedResponse(error)) {
                handleLoginExpired();
                return;
            }
            const { status, statusText } = error.response || {};
            console.log(`Error! HTTP Status: ${status} ${statusText}`);
        }
        handleClose();
    }
    //並び替えリセット
    function ResetOrder(params) {
        var rows = [];
        gridApi.forEachNode(function (node) {
           rows.push(node.data);
        });
        rows.sort((a, b) => a.seqno - b.seqno);
        gridApi.setGridOption("rowData", rows);
        handleClose();
    }
    //条件クリア
    function ClearTextAll() {
        gridApi.forEachNode(function (node) {
            node.setDataValue('value', '');
            node.setDataValue('value2', '');
            node.setDataValue('filter', '');
        });
        handleClose();
    }

    //agGrid event
    function onGridReady(params) {
        setGridApi(params.api);
        //setGridColumnApi(params.columnApi);
    }
    function onFirstDataRendered(params) {
        //前回条件値取得
        let itemdata = getSearchData();
        if (itemdata !== null) {
            setsearchindex(0);
            setSearchdata(itemdata[0].values)
        }
    }

    function onCellValueChanged(params, id) {
        if (params.newValue === params.oldValue) return;
        if (params.newValue === "") return;
        if (params.colDef.field === 'filter') return;
        if (isMaster(params.data.columnid)) {
            let colinfo = getcolinfo(params.data.columnid);
            if (isEmpty(colinfo)) return;
            let rowNode = params.api.getRowNode(params.data.columnid);
            LinkFieldApply(colinfo, params.newValue, rowNode);
        }
    }
    function LinkFieldApply(colinfo, value, rowNode) {
        if (!props.fnc.existMaster(colinfo.dataid, value)) {
            //サーバーより情報を取得
            props.fnc.getMasterdata(colinfo.dataid, value,'', [], null, (data) => callback(data, colinfo, rowNode),'nowait');
        }
        function callback(data, colinfo, rowNode) {
            if (!isEmpty(data)) {
                props.fnc.setMaster(data);
            }
            if (rowNode !== undefined) {
                if (colinfo.datatype === CELLTYPE.MASTER || colinfo.datatype === CELLTYPE.MASTERCODE) {
                    //セル内名称表示
                    var params = {
                        suppressFlash: true,
                        rowNodes: [rowNode],
                    };
                    gridApi.refreshCells(params);
                }
            }
        }
    }
    function onClose() {
    //    props.fnc.searchpanelclose();
        props.onClose();
    }

    function searchvalues() {
        var itemdata = {};
        gridApi.forEachNode(function (node) {
            if (!isEmpty(node.data.value)) {
                itemdata[node.data.columnid] = node.data.value;
            }
        });
        return itemdata;
    }
    const labelCellStyle = { 'font-size': '10px', backgroundColor: '#888', color: 'white' };
    function valueParser(params) {
        if (params.newValue === '') {
            return params.newValue;
        }

        if (params.data.datatype === CELLTYPE.NUMBER) {
            if (!isFinite(params.newValue))
                return '';
        }
        if (params.data.datatype === CELLTYPE.DATE || params.data.datatype === CELLTYPE.SEARCHDATE) {
            try {
                let parseString = parse(new Date(), 'yyyy/MM/dd');
                let date = parseString(params.newValue);
                if (!isValid(date))
                    return '';
            } catch {
                return '';
            }
        }
        if (params.data.datatype === CELLTYPE.SELECT) {
            let result = params.data.options.find(e => e.code === params.newValue);
            if (result === null)
                return '';
        }
        return params.newValue;
    }
    function valueFormatter(params) {
        if (params.value === '') return params.value;

        try {
            if (params.data.datatype === CELLTYPE.NUM) {
                var number = params.value;
                return Math.floor(number)
                    .toString()
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            }
            if (params.data.datatype === CELLTYPE.DATE) {
            }
            if (params.data.datatype === CELLTYPE.MASTER || params.data.datatype === CELLTYPE.MASTERCODE) {
                let colinfo = getcolinfo(params.data.columnid);
                if (!isEmpty(colinfo)) {
                    let data = props.fnc.getMaster(colinfo.dataid, params.value);
                    if (data !== null) {
                        if ('name' in data) {
                            return params.value + " " + data['name'];
                        }
                        if (colinfo.dbcolumn in data) {
                            return params.value + " " + data[colinfo.dbcolumn];
                        }
                    }
                }
                return params.value;
            }
            if (params.data.datatype === CELLTYPE.SELECT || params.data.datatype === CELLTYPE.CHECK || params.data.datatype === CELLTYPE.SPIN) {
                let result = params.data.options.find(e => e.code === params.data.value);
                if (result !== null)
                    return params.value + " " + result.name;
                return params.value;
            }

        } catch {
            return params.value;
        }
    }

    const columnDefs = [
        { headerName: "項目", field: 'label', width: 140, cellStyle: labelCellStyle, editable: false, rowDrag: true, suppressColumnsToolPanel: true},
        {
            headerName: "検索値", field: 'value', width: 180,
            cellStyle: { border: '0.5px solid #ccc', borderTopWidth: 0, borderLeftWidth: 0, borderBottomWidth: 0 },
            colSpan: function (params) {
                if (params.data.datatype === CELLTYPE.DATE || params.data.datatype === CELLTYPE.NUM || params.data.datatype === CELLTYPE.SEARCHYMRANGE ||
                    params.data.datatype === CELLTYPE.SEARCHYMRANGESTR || params.data.datatype === CELLTYPE.SEARCHTEXTRANGE) {
                    return 1;
                } else {
                    return 2;
                }
            },
            cellRenderer: InputRenderer,
            cellRendererParams: {
                clicked: function (e) {
                    e.api.stopEditing();
                    if (e.data.datatype === CELLTYPE.DATE || e.data.datatype === CELLTYPE.YEAR ||
                        e.data.datatype === CELLTYPE.SEARCHDATE || e.data.datatype === CELLTYPE.SEARCHYM || e.data.datatype === CELLTYPE.SEARCHYMRANGE ||
                        e.data.datatype === CELLTYPE.SEARCHYMSTR || e.data.datatype === CELLTYPE.SEARCHYMRANGESTR) {
                        props.fnc.searchlistopen({
                            label: e.data.label,
                            data: e.data,
                            rowid: e.datarowid,
                            doApply: setsearchitem,
                        });
                    } else {
                        //マスタリスト
                        setslmultiple(e.data.datatype === CELLTYPE.MASTER || e.data.datatype === CELLTYPE.MASTERCODE);
                        setsllabel(e.data.label);
                        setsldata(e.data);
                        setslrowdata(searchvalues);
                        setslrowid(e.data.rowid);
                        setsldoApply(0);
                        setslopen(true);
                    }
                },
                clear: function (e) {
                    gridApi.stopEditing();
                    e.node.setDataValue('value', "");
                }
            },
            valueParser: valueParser,
            valueFormatter: valueFormatter,
        },
        {
            headerName: "", field: 'value2', width: 180,
            cellStyle: { border: '0.5px solid #ccc', borderTopWidth: 0, borderLeftWidth: 0, borderBottomWidth: 0 },
            cellRenderer: InputRenderer,
            cellRendererParams: {
                clicked: function (e) {
                    e.api.stopEditing();
                    if (e.data.datatype === CELLTYPE.DATE || e.data.datatype === CELLTYPE.SEARCHDATE || e.data.datatype === CELLTYPE.SEARCHYM || e.data.datatype === CELLTYPE.SEARCHYMRANGE ||
                        e.data.datatype === CELLTYPE.SEARCHYMSTR || e.data.datatype === CELLTYPE.SEARCHYMRANGESTR) {
                        props.fnc.searchlistopen({
                            label: e.data.label,
                            data: e.data,
                            rowid: e.datarowid,
                            doApply: setsearchitem2,
                        });
                    } else {
                        //マスタリスト
                        setslmultiple(false);
                        setsllabel(e.data.label);
                        setsldata(e.data);
                        setslrowid(e.data.rowid);
                        setsldoApply(1);
                        setslopen(true);
                    }
                },
                clear: function (e) {
                    gridApi.stopEditing();
                    e.node.setDataValue('value2', "");
                }
            },
            valueParser: valueParser,
            valueFormatter: valueFormatter,
        },
        {
            headerName: "option", field: 'filter', width: 90,
            cellStyle: { border: '0.5px solid #ccc', borderTopWidth: 0, borderLeftWidth: 0, borderBottomWidth: 0 },
            editable: function (params) {
                if (params.data.datatype === CELLTYPE.SELECT || params.data.datatype === CELLTYPE.SEARCHTEXTRANGE || params.data.dataid === "p_storage" ||
                    params.data.datatype === CELLTYPE.RADIO ) return false;
                if (params.data.desableoption) return false;
                return params.data.datatype !== CELLTYPE.SELECT && params.data.datatype !== CELLTYPE.SEARCHNUM &&
                    params.data.datatype !== CELLTYPE.SEARCHDATE && params.data.datatype !== CELLTYPE.SEARCHYM &&
                    params.data.datatype !== CELLTYPE.SEARCHDATESTR && params.data.datatype !== CELLTYPE.SEARCHYMSTR
            },
            cellEditorSelector: function (params) {
                if (params.data.datatype === CELLTYPE.SELECT || params.data.datatype === CELLTYPE.SEARCHTEXTRANGE || params.data.dataid === "p_storage")
                    return null;
                if (params.data.datatype === CELLTYPE.DATE || params.data.datatype === CELLTYPE.NUM ||
                    params.data.datatype === CELLTYPE.MASTER || params.data.datatype === CELLTYPE.MASTERCODE) {
                    return {
                        component: 'agSelectCellEditor',
                        params: {
                            values: ['', '除外', '値なし'],
                        }
                    };
                } else {
                    return {
                        component: 'agSelectCellEditor',
                        params: {
                            values: ['', '曖昧', '除外', '曖昧 除外', '値なし','複数指定'],
                        }
                    };
                }
            }
        }
    ];

    return (
        <div >
            <Drawer
                anchor={"right"} open={open} onClose={onClose}
                style={{ zIndex: props.subkey==='inner'?1500:1200 }}
            >
                <div style={{ margin: 10 }}>
                    <Button variant="outlined" size="small" onClick={Execute}>実行</Button>
                </div>
                <div style={{ position: 'absolute', Top: 0, right: 80 }} >
                    <IconButton title={"現在条件"} onClick={curSearch}>
                        <Icon>place</Icon>
                    </IconButton>
                    <IconButton title={"前の条件"} onClick={prevSearch} disabled={ preSearchDisable}>
                        <Icon className={"transform"}>play_circle_outline</Icon>
                    </IconButton>
                    <IconButton title={"次の条件"} onClick={nextSearch} disabled={nextSearchDisable}>
                        <Icon>play_circle_outline</Icon>
                    </IconButton>
                </div>
                <div style={{ position: 'absolute', Top: 0, right: 0 }} >
                    <IconButton aria-label="検索条件設定メニュ" title={"設定"} aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                        <Icon>menu</Icon>
                    </IconButton>
                </div>
                <DatePicker
                    selected={startDate}
                    onChange={onDateChange}
                    customInput={<DatePickerCustomInput />}
                />
               <div style={{ height: 'calc(100% - 60px)', width: '100%'}}>
                    <div className="ag-theme-balham" style={{ height: '100%', width: 600 }}>
                        <AgGridReact
                           theme={themeBalham}
                           columnMenu="legacy"
                           defaultColDef={{
                                lockPosition:true,
                                editable: true,
                               menuTabs: [],
                            }}
                            modules={[AllCommunityModule, AllEnterpriseModule]}
                            getRowNodeId={function (data) {
                                return data.columnid;
                            }}
                            rowSelection={'single'}
                            headerHeight={30}
                            rowDragManaged={true}
                            onCellValueChanged={onCellValueChanged}
                            onGridReady={onGridReady}
                            onFirstDataRendered={onFirstDataRendered}
                            columnDefs={columnDefs}
                            rowData={rowData}>
                        </AgGridReact>
                    </div>
                </div>

                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem onClick={curSearch}>現在の抽出条件を表示</MenuItem>
                    <MenuItem onClick={prevSearch}>前の抽出条件を表示</MenuItem>
                    <MenuItem onClick={nextSearch}>次の抽出条件を表示</MenuItem>
                    <Divider />
                    <MenuItem onClick={SaveOrder}>現在の条件項目の並び順を保存</MenuItem>
                    <MenuItem onClick={ResetOrder}>並び順をリセット</MenuItem>
                    <Divider />
                    <MenuItem onClick={ClearTextAll}>条件クリア</MenuItem>
                    <Divider />
                    <MenuItem onClick={SaveCondition}>現在の抽出条件を起動時条件に適用</MenuItem>
                    <MenuItem onClick={RemoveCondition}>起動時条件をクリア</MenuItem>
                    <MenuItem onClick={showCondition}>起動時条件を表示</MenuItem>
               </Menu>

                <SearchList
                    inTag={false} SearchPanel={true} zindex={props.subkey === 'inner' ? 1500 : 1200}
                    open={slopen}
                    doclose={()=>setslopen(false)}
                    multiple={slmultiple}
                    rowmode={false}
                    label={sllabel}
                    data={sldata}
                    rowdata={slrowdata }
                    rowid={slrowid}
                    doApply={sldoApply === 0 ? setsearchitem:setsearchitem2}
                    taglist={[]}
                    insearchtag={[]}
                />
            </Drawer>
        </div>
    );
};
